import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { appInitialize } from './store/saga/initial/actions';
import { useAppData } from './hooks/useAppData';
import { Page } from './components/Page';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const appData = useAppData();
  useEffect(() => {
    if (appData.status === 'init') {
      dispatch(appInitialize());
    }
  }, [appData.status, dispatch]);

  const routerItems = useMemo(
    () =>
      Object.entries(appData.pages).map(([id, page]) => ({
        id,
        path: page.path,
        element: <Page page={{ ...page, id }} settings={appData.settings} />,
      })),
    [appData.pages, appData.settings]
  );

  const router = useMemo(() => {
    return createBrowserRouter(routerItems);
  }, [routerItems]);

  return <RouterProvider router={router} />;
};

export default App;
